import TitleSectionAccount from './TitleSectionAccount';

export default TitleSectionAccount;
